import React from 'react';

import {
  QuestionCircleIcon, DropletIcon, MinusCircleIcon, CheckIcon,
} from '@vlabs/icons';
import { Divider, Control } from '@vlabs/uikit';
import cn from 'classnames';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './ColorBoxFilter.module.sass';
import { isSelected, toggleOption } from '../../helpers';

export function ColorBoxFilter({
  control,
  name,
  label,
  options,
  isMulti = false,
  showResetButton = true,
}) {
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      defaultValue={isMulti ? [] : null}
      name={name}
      render={({ field }) => {
        const { value, onChange } = field;
        const safeArray = Array.isArray(value) ? value : [];

        let selectedOptions = [];

        if (isMulti && Array.isArray(value)) {
          selectedOptions = value;
        } else if (value) {
          selectedOptions = [value];
        }

        const selectedLabels = selectedOptions.map((opt) => opt.label.toLowerCase()).join(', ');

        const hasValue = isMulti ? safeArray.length > 0 : !!value;
        const handleReset = () => {
          onChange(isMulti ? [] : null);
        };

        return (
          <div>
            {!!label && (
              <label className="Subtitle-2">
                {label}
                {selectedLabels && ': '}
              </label>
            )}

            {!!selectedLabels && <span>{selectedLabels}</span>}

            <Divider small />

            <div className={st.ColorsGrid}>
              {options.map((option) => {
                const isActive = isSelected(safeArray, option, isMulti);
                const colorClass = st[`ColorIcon_${option.value}`];
                const withIconValue = (option.value === 'undefined')
                  || (option.value === 'other')
                  || (option.value === 'null');

                return (
                  <div
                    aria-label={option.label}
                    className={cn(st.ColorIcon, colorClass, {
                      [st.ColorIcon_activeBorder]: isActive && withIconValue,
                    })}
                    key={option.value}
                    onClick={() => onChange(toggleOption(safeArray, option, isMulti))}
                    onKeyDown={() => onChange(toggleOption(safeArray, option, isMulti))}
                    role="button"
                    tabIndex={0}
                    title={option.label}
                  >
                    {option.value === 'undefined' && <QuestionCircleIcon className={st.InnerIcon} />}
                    {option.value === 'other' && <DropletIcon className={st.InnerIcon} />}
                    {option.value === 'null' && <MinusCircleIcon className={st.InnerIcon} />}
                    {!!isActive && !withIconValue && <CheckIcon className={st.InnerIcon} />}
                  </div>
                );
              })}
            </div>

            <Divider small />

            {!!showResetButton && (
              <Control.Button
                disabled={!hasValue}
                kind="negative"
                onClick={handleReset}
                size="small"
                variant="filled"
              >
                {t('button.clear')}
              </Control.Button>
            )}
          </div>
        );
      }}
    />
  );
}
